import { render } from "./IncidenciasPage.vue?vue&type=template&id=0022b2f4"
import script from "./IncidenciasPage.vue?vue&type=script&lang=js"
export * from "./IncidenciasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__